import { useMemo } from 'react'
import { Trans } from 'react-i18next'

import translationKeys from '@translationKeys'

import TruncateLines from '@components/TruncateLines'
import { CustomColumnType } from '@modules/shortlist/types'

import CustomColumnDropdown from '../CustomColumnPopover/CustomColumnDropdown'
import { CustomColumnCellContent, NoteButtonLabel, StyledNoteButton } from '../index.styles'
import { CellInfo } from '../types'

export const CustomColumnCell = (info: CellInfo) => {
  const {
    row: { original: profileData },
    cell: {
      column: {
        // @ts-expect-error TODO: column def typing
        columnDef: { fieldType, fieldName, fieldOptions, columnTitle },
      },
    },
    meta: { onCustomColumnClick, activeShortlist },
  } = info

  const itemId = useMemo(() => Number(fieldName!), [fieldName])

  return (
    <CustomColumnCellContent>
      {fieldType === CustomColumnType.FREE_TEXT ? (
        <StyledNoteButton
          variant="text"
          onClick={e =>
            onCustomColumnClick(e, {
              profileId: profileData.profileId,
              fieldId: itemId,
              customFieldValue: profileData.customFieldValues?.[itemId] ?? '',
            })
          }
        >
          {profileData.customFieldValues?.[itemId] ? (
            <TruncateLines lines={5}>{profileData.customFieldValues?.[itemId]}</TruncateLines>
          ) : (
            <NoteButtonLabel>
              <Trans>{translationKeys.ADD_TEXT_HERE}</Trans>
            </NoteButtonLabel>
          )}
        </StyledNoteButton>
      ) : (
        <CustomColumnDropdown
          shortlistId={activeShortlist?.id ?? 0}
          profileId={profileData.profileId}
          customFieldId={itemId}
          availableOptions={fieldOptions}
          columnName={columnTitle || ''}
          selectedOptionId={profileData.customFieldValues?.[itemId] ?? ''}
          onOptionSelect={(selectedProfileId, fieldId, value) =>
            onCustomColumnClick(null, {
              profileId: selectedProfileId,
              fieldId,
              customFieldValue: value,
            })
          }
        />
      )}
    </CustomColumnCellContent>
  )
}
